module.exports = __webpack_public_path__ + "img/sec5_13.0571f4f7.jpg";